module.exports = __webpack_public_path__ + "media/images/tailwind/logo-university-1ada292c48d82a4d6d896185bfbffcb0.png";